import { Overlay } from 'trading-vue-js';

export default {
    name: 'PerfectTrades',
    mixins: [Overlay],
    methods: {
        draw(ctx) {
            // needed data : [0 timestamp, 1 type(sell, buy, close), 2 price, 3 value, 4 duration(ie, end time stamp), 5 spread]
            const layout = this.$props.layout; // Layout object (see API BOOK)
            ctx.lineWidth = 0.9;
            if (this.trade_type == 'up-down') {
                ctx.setLineDash([1, 5]);
                let ask = layout.$2screen(this.curr_price + this.curr_spread);
                let bid = layout.$2screen(this.curr_price - this.curr_spread);
                ctx.beginPath();
                ctx.strokeStyle = this.buy_color;
                ctx.moveTo(0, ask);
                ctx.lineTo(layout.width, ask);
                ctx.stroke();

                ctx.beginPath();
                ctx.strokeStyle = this.sell_color;
                ctx.moveTo(0, bid);
                ctx.lineTo(layout.width, bid);
                ctx.stroke();
                ctx.setLineDash([]);
            } else if (this.p_Type != 'in' && this.p_Type != 'out') {
                const userMult = this.user_mult > 0 ? this.user_mult : 0.25;
                let outUp = layout.$2screen(this.curr_price + this.curr_spread * this.out_mult);
                let outDown = layout.$2screen(this.curr_price - this.curr_spread * this.out_mult);
                let inUp = layout.$2screen(this.curr_price + this.curr_spread * (this.in_mult / userMult));
                let inDown = layout.$2screen(this.curr_price - this.curr_spread * (this.in_mult / userMult));
                ctx.strokeStyle = this.buy_color;
                ctx.fillStyle = `${this.buy_color}11`;
                ctx.moveTo(0, outUp);
                ctx.lineTo(layout.width, outUp);
                ctx.stroke();
                ctx.moveTo(0, outDown);
                ctx.lineTo(layout.width, outDown);
                ctx.fillRect(0, outUp, layout.width, -layout.height);
                ctx.fillRect(0, outDown, layout.width, layout.height);
                ctx.stroke();
                ctx.beginPath();
                ctx.strokeStyle = this.sell_color;
                ctx.fillStyle = `${this.sell_color}11`;
                ctx.moveTo(0, inUp);
                ctx.lineTo(layout.width, inUp);
                ctx.stroke();
                ctx.moveTo(0, inDown);
                ctx.lineTo(layout.width, inDown);
                ctx.fillRect(0, inUp, layout.width, inDown - inUp);
                ctx.stroke();
            }
            ctx.lineWidth = 1.5;
            for (var i in this.$props.data) {
                let p = this.$props.data[i];

                // We use previos point here, but the profit should
                // be already in the data (in a real usecase)
                let prev = this.$props.data[i - 1];
                let next = this.$props.data[i + 1];
                ctx.strokeStyle = '#555';

                if (p[1] == 1 || p[1] == 2 || p[1] == 6 || p[1] == 7) {
                    ctx.fillStyle = p[1] == 1 || p[1] == 7 ? this.buy_color : p[1] == 0 || p[1] == 6 ? this.sell_color : this.close_color;
                } else if (prev && p[1] == 3) {
                    ctx.fillStyle = p[3] > 0 ? this.buy_color : p[3] < 0 ? this.sell_color : this.close_color;
                } else if (p[1] == 4 || p[1] == 5) {
                    if (next) {
                        ctx.fillStyle =
                            (next[2] - next[5] > p[2] && p[1] == 5) || (next[2] + next[5] < p[2] && p[1] == 4)
                                ? this.buy_color
                                : (next[2] - next[5] <= p[2] && p[1] == 5) || (next[2] + next[5] >= p[2] && p[1] == 4)
                                ? this.sell_color
                                : '#777';
                    } else {
                        ctx.fillStyle = '#FFFFFF00';
                    }
                } else {
                    ctx.fillStyle = '#777';
                }

                let x = layout.t_magnet(p[0]); // x - Mapping
                let y = layout.$2screen(p[2]); // y - Mapping
                if (p[1] == 0 || p[1] == 1) {
                    let x1 = layout.t_magnet(p[0]); // x - Mapping
                    let y1 = layout.$2screen(p[2]);
                    if (p[1] == 1) {
                        ctx.beginPath();
                        ctx.moveTo(x1 - 5, y1 + 5);
                        ctx.lineTo(x1, y1 - 5);
                        ctx.lineTo(x1 + 5, y1 + 5);
                        ctx.closePath();
                        ctx.fill();
                        ctx.stroke();
                    } else if (p[1] == 0) {
                        ctx.beginPath();
                        ctx.moveTo(x1, y1 + 5);
                        ctx.lineTo(x1 - 5, y1 - 5);
                        ctx.lineTo(x1 + 5, y1 - 5);
                        ctx.closePath();
                        ctx.fill();
                        ctx.stroke();
                    }
                } else if (prev && p[1] == 3) {
                    let x1 = layout.t_magnet(p[7]); // x - Mapping
                    let y1 = layout.$2screen(p[8]);
                    ctx.beginPath();
                    ctx.arc(x, y, this.marker_size + 0.5, 0, Math.PI * 2, true);
                    ctx.fill();
                    ctx.stroke();
                    if (p[6] == 1 || p[6] == 5) {
                        ctx.beginPath();
                        ctx.moveTo(x1 - 5, y1 + 5);
                        ctx.lineTo(x1, y1 - 5);
                        ctx.lineTo(x1 + 5, y1 + 5);
                        ctx.closePath();
                        ctx.fill();
                        ctx.stroke();
                    } else if (p[6] == 0 || p[6] == 4) {
                        ctx.beginPath();
                        ctx.moveTo(x1, y1 + 5);
                        ctx.lineTo(x1 - 5, y1 - 5);
                        ctx.lineTo(x1 + 5, y1 - 5);
                        ctx.closePath();
                        ctx.fill();
                        ctx.stroke();
                    } else if (p[6] == 7) {
                        ctx.beginPath();
                        ctx.moveTo(x1 - 5, y1);
                        ctx.lineTo(x1 + 5, y1);
                        ctx.lineTo(x1, y1 + 7);
                        ctx.closePath();
                        ctx.fill();
                        ctx.stroke();
                        ctx.beginPath();
                        ctx.moveTo(x1 - 5, y1);
                        ctx.lineTo(x1 + 5, y1);
                        ctx.lineTo(x1, y1 - 7);
                        ctx.closePath();
                        ctx.fill();
                        ctx.stroke();
                    } else if (p[6] == 6) {
                        ctx.beginPath();
                        ctx.moveTo(x1, y1);
                        ctx.lineTo(x1 - 5, y1 + 7);
                        ctx.lineTo(x1 + 5, y1 + 7);
                        ctx.closePath();
                        ctx.fill();
                        ctx.stroke();
                        ctx.beginPath();
                        ctx.moveTo(x1, y1);
                        ctx.lineTo(x1 - 5, y1 - 7);
                        ctx.lineTo(x1 + 5, y1 - 7);
                        ctx.closePath();
                        ctx.fill();
                        ctx.stroke();
                    }
                } else if (p[1] == 7) {
                    let x1 = layout.t_magnet(p[0]); // x - Mapping
                    let y1 = layout.$2screen(p[2]);

                    ctx.beginPath();
                    ctx.moveTo(x1 - 5, y1);
                    ctx.lineTo(x1 + 5, y1);
                    ctx.lineTo(x1, y1 + 7);
                    ctx.closePath();
                    ctx.fill();
                    ctx.stroke();
                    ctx.beginPath();
                    ctx.moveTo(x1 - 5, y1);
                    ctx.lineTo(x1 + 5, y1);
                    ctx.lineTo(x1, y1 - 7);
                    ctx.closePath();
                    ctx.fill();
                    ctx.stroke();
                } else if (p[1] == 6) {
                    let x1 = layout.t_magnet(p[0]); // x - Mapping
                    let y1 = layout.$2screen(p[2]);
                    ctx.beginPath();
                    ctx.moveTo(x1, y1);
                    ctx.lineTo(x1 - 5, y1 + 7);
                    ctx.lineTo(x1 + 5, y1 + 7);
                    ctx.closePath();
                    ctx.fill();
                    ctx.stroke();
                    ctx.beginPath();
                    ctx.moveTo(x1, y1);
                    ctx.lineTo(x1 - 5, y1 - 7);
                    ctx.lineTo(x1 + 5, y1 - 7);
                    ctx.closePath();
                    ctx.fill();
                    ctx.stroke();
                } else if (p[1] != 4 && p[1] != 5) {
                    ctx.beginPath();
                    ctx.arc(x, y, this.marker_size + 0.5, 0, Math.PI * 2, true);
                    ctx.fill();
                    ctx.stroke();
                }
                ctx.beginPath();
                ctx.strokeStyle = p[1] == 1 || p[1] == 7 ? this.buy_color : p[1] == 0 || p[1] == 6 ? this.sell_color : this.close_color;
                if (prev && p[1] == 3) {
                    ctx.strokeStyle = p[3] > 0 ? this.buy_color : p[3] < 0 ? this.sell_color : this.close_color;
                }

                if (p[1] === 0 || p[1] === 1 || p[1] === 6 || p[1] === 7) {
                    let x2 = layout.t2screen(p[4]); // x - Mapping - if index based -> p[0] + p[4]
                    let y2 = layout.$2screen(p[2]);
                    ctx.moveTo(x, y);

                    ctx.lineTo(x2 + 6, y2);
                    ctx.fill();
                    ctx.stroke();
                    ctx.beginPath();
                    ctx.strokeStyle = '#555';
                    ctx.moveTo(x2 + 6, y2 + 1000);
                    ctx.lineTo(x2 + 6, y2 - 1000);
                    ctx.stroke();
                    ctx.fill();
                    ctx.lineWidth = 0.9;
                    ctx.setLineDash([1, 5]);
                    if (p[1] === 6) {
                        let inUp = layout.$2screen(p[2] + p[5] * (this.in_mult / this.user_mult));
                        let inDown = layout.$2screen(p[2] - p[5] * (this.in_mult / this.user_mult));
                        ctx.fillStyle = `${this.sell_color}11`;
                        ctx.beginPath();
                        ctx.moveTo(0, inUp);
                        ctx.lineTo(layout.width, inUp);
                        ctx.stroke();
                        ctx.moveTo(0, inDown);
                        ctx.lineTo(layout.width, inDown);
                        ctx.fillRect(0, inUp, layout.width, inDown - inUp);
                        ctx.stroke();
                    } else if (p[1] === 7) {
                        let outUp = layout.$2screen(p[2] + p[5] * this.out_mult);
                        let outDown = layout.$2screen(p[2] - p[5] * this.out_mult);
                        ctx.fillStyle = `${this.buy_color}11`;
                        ctx.moveTo(0, outUp);
                        ctx.lineTo(layout.width, outUp);
                        ctx.stroke();
                        ctx.moveTo(0, outDown);
                        ctx.lineTo(layout.width, outDown);
                        ctx.fillRect(0, outUp, layout.width, -layout.height);
                        ctx.fillRect(0, outDown, layout.width, layout.height);
                        ctx.stroke();
                    } else {
                    }

                    ctx.lineWidth = 1.5;
                    ctx.setLineDash([]);
                } else if (prev && p[1] == 3) {
                    let x2 = layout.t_magnet(p[7]); // x - Mapping
                    let y2 = layout.$2screen(p[8]);
                    ctx.beginPath();
                    ctx.moveTo(x, y);
                    ctx.lineTo(x2, y2);
                    ctx.stroke();
                    ctx.fill();
                }
                if (this.show_label && (p[1] === 0 || p[1] === 1 || p[1] === 6 || p[1] === 7)) {
                    //let profit = p[2] / prev[2] - 1;
                    let profit = this.is_profit(p) ? (p[3] * 0.85).toFixed(2) : -p[3];
                    let time = new Date(this.left_duration);
                    let duration = `${time.getHours() - 3}:${time.getMinutes() < 10 ? '0' + String(time.getMinutes()) : time.getMinutes()}:${time.getSeconds() < 10 ? '0' + String(time.getSeconds()) : time.getSeconds()}`;
                    let label = `${profit} €`;
                    ctx.fillStyle = this.night_mode ? '#fff' : '#1e1e1e';
                    //ctx.fillStyle = this.is_profit(p) ? this.buy_color : this.sell_color;
                    //ctx.fillStyle = '#999';
                    ctx.font = '12px Arial';
                    ctx.textAlign = 'center';
                    ctx.fillText(`${label}`, x, y - 25);
                    label = `⏱️ ${duration}`;
                    ctx.fillStyle = '#777';
                    ctx.font = '12px Arial';
                    ctx.textAlign = 'center';
                    ctx.fillText(label, x, y + 25);
                }

                if (this.show_label && p[1] === 3 && prev) {
                    let profit = `${p[3].toFixed(2)} €`;
                    ctx.fillStyle = this.night_mode ? '#fff' : '#1e1e1e';
                    //ctx.fillStyle = p[3] > 0 ? this.buy_color : this.sell_color;
                    //ctx.fillStyle = '#999';
                    ctx.font = '14px Arial';
                    ctx.textAlign = 'center';
                    ctx.fillText(profit, x, y - 25);
                }
            }
        },
        use_for() {
            return ['PerfectTrades'];
        },
        legend(values) {
            return [
                {
                    value: `${values[1] != 3 ? 'Opened' : 'Closed'} at ${new Date(values[0]).toLocaleTimeString().replace(':00', '')}`, // custom formatter
                    color: `${values[1] != 3 ? '#777' : values[3] < 0 ? this.sell_color : this.buy_color}`, // custom formatter
                },

                {
                    value: `${
                        values[1] == 0 || values[1] == 4 || values[1] == 1 || values[1] == 5 ? 'Value : ' + values[3]?.toFixed(2) + ' €' : values[3] < 0 ? 'Loss : ' + values[3]?.toFixed(2) + ' €' : 'Profit : ' + values[3]?.toFixed(2) + ' €'
                    }`,
                    color: `${values[1] != 3 ? '#777' : values[3] < 0 ? this.sell_color : this.buy_color}`,
                },
            ];
        },

        is_profit(p) {
            if (p[1] == 0 && this.curr_price + this.curr_spread < p[2]) {
                return true;
            }
            if (p[1] == 1 && this.curr_price - this.curr_spread > p[2]) {
                return true;
            }
            if (p[1] == 6 && p[2] + p[5] * (this.in_mult / this.user_mult) > this.curr_price && p[2] - p[5] * (this.in_mult / this.user_mult) < this.curr_price) {
                return true;
            }
            if (p[1] == 7 && !(p[2] + p[5] * this.out_mult > this.curr_price && p[2] - p[5] * this.out_mult < this.curr_price)) {
                return true;
            }
            return false;
        },
        meta_info() {
            return {
                author: 'Satoshi Smith',
                version: '1.0.0',
                desc: /*opt*/ 'Brief description',
                contact: /*opt*/ '<email>',
                github: /*opt*/ '<GitHub Page>',
            };
        },
    },
    settings: {
        buyColor: '#bfff00',
        sellColor: '#ec4662',
        markerSize: 5,
        showLabel: true,
    },
    // Define internal setting & constants here
    computed: {
        sett() {
            // Just an alias
            return this.$props.settings;
        },
        buy_color() {
            return this.sett['buyColor'] || '#4CAF50'; // default value
        },
        sell_color() {
            return this.sett['sellColor'] || '#ec4662';
        },
        close_color() {
            return this.sett['closeColor'] || '#007BFF';
        },
        curr_price() {
            let val = this.sett['currentPrice'] || 0;
            return Number(val);
        },
        curr_spread() {
            let val = this.sett['spread'] || 0;
            return Number(val);
        },
        trade_type() {
            return this.sett['tradeType'] || 'up-down';
        },
        left_duration() {
            return this.sett['duration'] || 0;
        },
        marker_size() {
            return this.sett['markerSize'] || 5;
        },
        show_label() {
            return this.sett['showLabel'] !== false;
        },
        p_Type() {
            return this.sett['pType'] || 'none';
        },
        out_mult() {
            return this.sett['outMult'] || 10;
        },
        in_mult() {
            return this.sett['inMult'] || 5;
        },
        night_mode() {
            return this.sett['night'] !== false;
        },
        user_mult() {
            return this.sett['mult'] || 1;
        },
    },
};
